import NavbarCustomer from "../../components/NavbarCustomer";
import ResponsiveAppBar from "../../components/ResponsiveAppBar";
import React from "react";

import {
	Card,
	CardContent,
	Typography,
	Button,
	Divider,
	Box,
	Grid,
	Container,
} from "@mui/material";

/**@Images */
import User from "../../assets/img/user.png";
import Vendor from "../../assets/img/store.png";
import { useNavigate } from "react-router-dom";
export default function Login1() {
	const customer = JSON.parse(localStorage.getItem("authUser")) || null;
	const customerId = customer?._id || null;
	const navigate = useNavigate();

	/**@Handlers */
	const userLoginHandler = () => {
		navigate("/user-login");
	};
	const vendorLoginHandler = () => {
		navigate("/vendor-login");
	};

	const userSignupHandler = () => {
		navigate("/user-signup");
	};

	const vendorSignupHandler = () => {
		navigate("/register");
	};
	const cardInfo = [
		{
			img: User,
			header: "User",
			info: "Find the perfect venue for your event.",
			buttonText: "User login",
			signUpText: "Don't have a User Account?",
			signUpHyperLink: "Sign up",
			loginHandler: userLoginHandler,
			signUpHandler: userSignupHandler,
		},
		{
			img: Vendor,
			header: "Vendor",
			info: "Manage enquiries and edit your listings.",
			buttonText: "Vendor login",
			signUpText: "Don't have a Vendor Account?",
			signUpHyperLink: "Register your venue with us",
			loginHandler: vendorLoginHandler,
			signUpHandler: vendorSignupHandler,
		},
	];
	return (
		<div className="flex flex-col h-screen w-full">
			{/* {customerId ? (
				<div className="z-[999]">
					<NavbarCustomer />
				</div>
			) : ( */}
			<div className="z-[9999]">
				<ResponsiveAppBar />
			</div>
			{/* )} */}
			{/**@LargeScreens */}
			<Container
				maxWidth="lg"
				sx={{
					display: { xs: "none", lg: "flex" },
					py: 4,
					flexDirection: "column",
					justifyContent: "center",
					height: "100%",
				}}
			>
				{/* Page Title */}
				<Typography
					variant="h4"
					fontWeight="bold"
					align="center"
					gutterBottom
					sx={{ py: 2 }}
				>
					Log in
				</Typography>

				{/* Cards Grid */}
				<Grid container spacing={8} justifyContent="center" alignItems="center">
					{cardInfo.map((card, i) => (
						<Grid item xs={12} sm={10} md={5} lg={4} key={i}>
							<Card
								sx={{
									mx: "auto",
									boxShadow: 3,
									borderRadius: 3,
									textAlign: "center",
								}}
							>
								<CardContent>
									{/* Image */}
									<Box
										sx={{
											display: "flex",
											justifyContent: "center",
											mb: 3,
											mt: 2,
										}}
									>
										<Box
											component="img"
											src={card.img}
											alt={card.header}
											sx={{
												width: 100,
												height: 100,
												borderRadius: "50%",
												objectFit: "cover",
											}}
										/>
									</Box>

									{/* Header */}
									<Typography variant="h5" gutterBottom fontWeight="bold">
										{card.header}
									</Typography>

									{/* Info Text */}
									<Typography
										variant="body1"
										color="text.secondary"
										sx={{ mb: 4 }}
									>
										{card.info}
									</Typography>

									{/* Button */}
									<Button
										variant="contained"
										color="primary"
										fullWidth
										size="large"
										onClick={card.loginHandler}
										sx={{ borderRadius: 2 }}
									>
										{card.buttonText}
									</Button>

									{/* Divider */}
									<Divider sx={{ my: 4 }} />

									{/* Footer */}
									<Typography variant="body1" color="text.secondary">
										{card.signUpText}
									</Typography>
									<Button
										variant="text"
										size="medium"
										sx={{ mt: 1 }}
										onClick={card.signUpHandler}
									>
										{card.signUpHyperLink}
									</Button>
								</CardContent>
							</Card>
						</Grid>
					))}
				</Grid>
			</Container>

			{/**@MobileView */}
			<Grid
				container
				spacing={4}
				justifyContent="center"
				sx={{
					display: { xs: "flex", md: "flex", lg: "none" },
					px: { xs: 2, sm: 3 },
					py: 4,
				}}
			>
				<Grid item xs={12}>
					<Typography
						variant="h4"
						fontWeight="bold"
						align="center"
						gutterBottom
					>
						Log in
					</Typography>
				</Grid>

				{cardInfo.map((card, i) => (
					<React.Fragment key={i}>
						<Grid item xs={12} key={i}>
							<Box sx={{ textAlign: "center", px: 2 }}>
								{/* Header */}
								<Typography variant="h6" fontWeight="bold" gutterBottom>
									{card.header}
								</Typography>

								{/* Info Text */}
								<Typography
									variant="body2"
									color="text.secondary"
									sx={{ mb: 3 }}
								>
									{card.info}
								</Typography>

								<Box sx={{ display: "flex", justifyContent: "center" }}>
									<Button
										variant="contained"
										color="primary"
										onClick={card.loginHandler}
										sx={{
											width: "50%",
											borderRadius: 2,
											mb: 3,
										}}
									>
										{card.buttonText}
									</Button>
								</Box>

								{/* Divider and Sign Up */}
								{/* <Divider sx={{ mb: 3 }} /> */}

								<Typography variant="body2" color="text.secondary">
									{card.signUpText}
								</Typography>
								<Button
									variant="text"
									size="small"
									sx={{ mt: 1 }}
									onClick={card.signUpHandler}
								>
									{card.signUpHyperLink}
								</Button>
							</Box>
						</Grid>

						{i === 0 && (
							<Grid item xs={12}>
								<Divider
									sx={{
										height: "4px",
										backgroundColor: "primary.main",
										width: "60%",
										mx: "auto",
										borderRadius: 1,
									}}
								/>
							</Grid>
						)}
					</React.Fragment>
				))}
			</Grid>
		</div>
	);
}
